import clsx from 'clsx';
import styles from './AppliedFiltersChips.module.scss';

export function ChipSectionSeperator() {
  return (
    <div className='position-relative mt-6'>
      <div className={clsx(styles.andOperator, 'text-caption-1 text-secondary')}>AND</div>
      <div className={styles.chipSectionSeperator} />
    </div>
  );
}
